<template>
    <base-page>
        <!-- <titlu-pagina Titlu="Setari SMS" /> -->

        <el-row class="main-page">

            <el-col class="coloana" :span="16">
                <el-card style='margin:5px 0px 5px 0px'>
                    <div slot="header"> 
                        <span>Setari Email</span>

                        <el-button @click="save(current_settings)" style="float: right; padding: 6px 12px; " type="success" plain
                            round size="large"> Salveaza template email {{current_settings}}</el-button>
                        <!-- <el-button @click="sterge" style="float: right; padding: 6px 12px; margin: 0 10px;"
                            type="danger" plain round size="large"> Sterge </el-button> -->

                    </div>
                    <div class="nav" >
                            <span @click="current_settings = 'nou'" :class="current_settings == 'nou' ? 'active' : ''">Email nou </span>  /  <span @click="current_settings = 'amanare'" :class="current_settings == 'amanare' ? 'active' : ''"> Email amanare </span>  /  <span @click="current_settings = 'anulare'" :class="current_settings == 'anulare' ? 'active' : ''"> Email anulare</span> 
                    </div>
                    <el-form label-position="top" :model="Setari" :inline="false" :rules="rules" size="mini"
                        label-width="100%" ref='my-sms-form' @submit.prevent="save_sms">
                        <el-row v-show="current_settings == 'nou'">
                            <el-form-item label='Subiect email programare noua' prop="Subiect_nou">
                                <el-input @focus="switch_focus('Subiect_nou')" @blur="remove_focus()"
                                    v-model="Setari.Nou.Subiect"></el-input>

                            </el-form-item>

                            <el-form-item label="Continut email programare noua"  prop="Continut_nou">
                                <VueEditor v-model="Setari.Nou.Continut" 
                                @focus="switch_focus('Continut_nou')" @blur="remove_focus()"
                                
                                />

                            </el-form-item>

                          
                        </el-row>
                        <el-row v-show="current_settings == 'amanare'">
                            <el-form-item label='Subiect email amanare' prop="Subiect_amanare">
                                <el-input @focus="switch_focus('Subiect_amanare')" @blur="remove_focus()"
                                    v-model="Setari.Amanare.Subiect"></el-input>

                            </el-form-item>

                            <el-form-item label="Continut email amanare" prop="Continut_amanare">
                                <VueEditor v-model="Setari.Amanare.Continut" 
                                @focus="switch_focus('Continut_amanare')" @blur="remove_focus()"
                                />

                            </el-form-item>

                          
                        </el-row>
                        <el-row v-show="current_settings == 'anulare'">
                            <el-form-item label='Subiect email anulare' prop="Subiect_anulare">
                                <el-input @focus="switch_focus('Subiect_anulare')" @blur="remove_focus()"
                                    v-model="Setari.Anulare.Subiect"></el-input>

                            </el-form-item>

                            <el-form-item label="Continut email anulare" prop="Continut_anulare">
                                <VueEditor v-model="Setari.Anulare.Continut" 
                                @focus="switch_focus('Continut_anulare')" @blur="remove_focus()"
                                />

                            </el-form-item>

                          
                        </el-row>
                        <span class="commands">Comenzi rapide</span>
                        <hr />

                        <div class="commands-btn-area">
                            <el-button @click="quick_add('[Nume]')" size="mini">Nume</el-button>
                            <el-button @click="quick_add('[Prenume]')" size="mini">Prenume</el-button>
                            <el-button @click="quick_add('[NrAuto]')" size="mini">Nr auto</el-button>
                            <el-button @click="quick_add('[Data]')" size="mini">Data</el-button>
                            <el-button @click="quick_add('[Ora]')" size="mini">Ora</el-button>
                            <el-tooltip content="adresa Email client">
                                <el-button @click="quick_add('[Email]')" size="mini">Email</el-button>
                            </el-tooltip>
                            <el-button @click="quick_add('[Telefon]')" size="mini">Telefon</el-button>
                            <el-button @click="quick_add('[Marca]')" size="mini">Marca</el-button>
                            <el-button @click="quick_add('[Model]')" size="mini">Model</el-button>
                            <el-button @click="quick_add('[An]')" size="mini">An</el-button>
                            <el-button @click="quick_add('[Km]')" size="mini">Km</el-button>
                            <el-button @click="quick_add('[NrProgramare]')" size="mini">Nr Programare</el-button>
                            <el-tooltip content="Genereaza url-ul. Se introduce DOAR in casuta cu link a editorului.">
                                <el-button @click="quick_add('[LinkAnulare]')" size="mini">Link anulare</el-button>
                            </el-tooltip>
                            <el-tooltip content="Genereaza url-ul. Se introduce DOAR in casuta cu link a editorului.">
                                <el-button @click="quick_add('[LinkAmanare]')" size="mini">Link amanare</el-button>
                            </el-tooltip>
                            <el-tooltip content="Genereaza url-ul. Se introduce DOAR in casuta cu link a editorului. Se afiseaza doar daca este administrator flota sau are minim 1 deviz facturat">
                                <el-button @click="quick_add('[LinkIstoric]')" size="mini">Link istoric</el-button>
                            </el-tooltip>
                        </div>
                        <br />
                        <span class="commands">Testeaza email-ul</span>
                        <hr />
                        <el-form-item label="Adresa de email">
                            <el-input placeholder="Introduceti adresa de email unde doriti sa faceti testul"
                                v-model="Setari.Email"></el-input>
                        </el-form-item>

                        <div class="butoane">
                            <el-button @click="test_email(current_settings)" type="success" plain round size="small">Test email {{current_settings}} </el-button>
                        </div>
                    </el-form>

                </el-card>
            </el-col>
        </el-row>



    </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";
import { VueEditor } from 'vue2-editor';

export default {
    name: "Setari_email",
    extends: BasePage,
    components: {
        "base-page": BasePage,
        VueEditor,
        "titlu-pagina": TitluPagina,
    },
    data() {
        return {
            current_settings: 'nou',
            // Setari:{},

            Setari: {
                mode: '',
                Email: '',
                Nou: {
                    Subiect: '',
                    Continut: '',
                },
                Amanare: {
                    Subiect: '',
                    Continut: '',
                },
                Anulare:{
                    Subiect: '',
                    Continut: '',
                },
            },
            rules: {
                // Subiect_nou: [{ required: true, message: 'Campul este obligatoriu' }],
                // Continut_nou: [{ required: true, message: 'Campul este obligatoriu' }], 
                // Subiect_amanare: [{ required: true, message: 'Campul este obligatoriu' }],
                // Continut_amanare: [{ required: true, message: 'Campul este obligatoriu' }],
                // Subiect_anulare: [{ required: true, message: 'Campul este obligatoriu' }],
                // Continut_anulare: [{ required: true, message: 'Campul este obligatoriu' }],
            }

        };
    },
    methods: {
        sterge: async function () {

            if(this.current_settings == 'nou')    this.Setari.Nou      = {Subiect: '', Continut: ''};
            if(this.current_settings == 'amanare') this.Setari.Amanare = {Subiect: '', Continut: ''};
            if(this.current_settings == 'anulare') this.Setari.Anulare = {Subiect: '', Continut: ''};
        },

        switch_focus: function (prop) {
            switch (prop) {
                case 'Subiect_nou': {
                    this.Setari.mode = 'Subiect_nou';
                    break;
                };
                case 'Continut_nou': {
                    this.Setari.mode = 'Continut_nou';
                    break;
                };
                case 'Subiect_amanare': {
                    this.Setari.mode = 'Subiect_amanare';
                    break;
                };
                case 'Continut_amanare': {
                    this.Setari.mode = 'Continut_amanare';
                    break;
                }
                case 'Subiect_anulare': {
                    this.Setari.mode = 'Subiect_anulare';
                    break;
                } 
                case 'Continut_anulare': {
                    this.Setari.mode = 'Continut_anulare';
                    break;
                }
            }
        },

        remove_focus: function () {
            // console.log('nu mai e in focus');
        },

        quick_add: async function (word) {
            switch (this.Setari.mode) {
                case 'Subiect_nou': {
                    this.Setari.Nou.Subiect += ` ${word}`;
                    break;
                }                
                case 'Continut_nou': {
                    this.Setari.Nou.Continut +=  ` ${word}`;
                    break;
                }                
                case 'Subiect_amanare': {
                    this.Setari.Amanare.Subiect += ` ${word}`;
                    break;
                }
                case 'Continut_amanare': {
                    this.Setari.Amanare.Continut += ` ${word}`;
                    break;
                }
                case 'Subiect_anulare': {
                    this.Setari.Anluare.Subiect +=  ` ${word}`;
                    break;
                }
                case 'Continut_anulare': {
                    this.Setari.Anluare.Continut +=  ` ${word}`;
                    break;
                }
            }
        },

    async get_info(){
      var response                              = await this.post("admin/setari/index" );
      this.Setari.Nou.Subiect                   = response.Setari.EmailNouSubiect;
      this.Setari.Nou.Continut                  = response.Setari.EmailNouContinut;
      this.Setari.Amanare.Subiect               = response.Setari.EmailAmanareSubiect;
      this.Setari.Amanare.Continut              = response.Setari.EmailAmanareContinut;
      this.Setari.Anulare.Subiect               = response.Setari.EmailAnulareSubiect;
      this.Setari.Anulare.Continut              = response.Setari.EmailAnulareContinut;
    },


    test_email: async function (mode) {
        if ( this.Setari.Email == '' 
            || this.Setari.Email.length < 0
            || !(String(this.Setari.Email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))
        ) {
            this.$notify({
            title: "Eroare",
            message: "Trebuie sa specificati o adresa de email valida",
            type: "error"
            })
        } else if (
               (mode=='nou'     && (this.Setari.Nou.Subiect.length == 0 || this.Setari.Nou.Continut.length == 0))
            || (mode=='amanare' && (this.Setari.Amanare.Subiect.length == 0 || this.Setari.Amanare.Continut.length == 0))
            || (mode=='anulare' && (this.Setari.Anulare.Subiect.length == 0 || this.Setari.Anulare.Continut.length == 0))
            )
        {
            this.$notify({
            title: "Eroare",
            message: "Subiectul sau continutul nu pot fi goale",
            type: "error"
            })

        } else {
            let response = await this.post('admin/setari/test_email', {Setari: this.Setari, Mode: mode});
            if(response.Success){
                this.$notify({
                    title: 'Succes',
                    message: 'Emailul a fost trimis cu succes!',
                    type: 'success',
                });
            } else {
                this.$notify({
                    title: 'Eroare',
                    message: response.Mesaj,
                    type: 'error',
                });
            }
        }
    },

      
    save: async function(mode) {

        if (
               (mode=='nou'     && (this.Setari.Nou.Subiect.length == 0 || this.Setari.Nou.Continut.length == 0))
            || (mode=='amanare' && (this.Setari.Amanare.Subiect.length == 0 || this.Setari.Amanare.Continut.length == 0))
            || (mode=='anulare' && (this.Setari.Anulare.Subiect.length == 0 || this.Setari.Anulare.Continut.length == 0))
            )
        {
            this.$notify({
            title: "Eroare",
            message: "Subiectul sau continutul nu pot fi goale",
            type: "error"
            })
            return;
        }

        var save_email_response = await this.post('admin/setari/save_email', {mode: mode, setari: this.Setari});
          if (save_email_response.Raspuns) {
            this.$notify({
                    title: 'Succes',
                    message: 'Modificarile au fost salvate pentru email ' + mode,
                    type: 'success',
                });
            } else {
                this.$notify({
                    title: 'Eroare',
                    message: 'A aparut o problema - modificarile nu au fost salvate!',
                    type: 'error',
                });
          }
    },

    },


    mounted() {
        if (!this.$has_right('Management')) {
            this.$router.push("/no-rights");
            return;
        }
        this.base_url = settings.BASE_URL;
        this.get_info();
        this.current_settings = 'nou';
    },
};
</script>

<style lang="less" scoped>
.main-page {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;
}

.commands {
    font-size: 14px;
    opacity: 0.3;
}

.commands-btn-area {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;

    .el-button {
        margin: 5px 0;
        width: 30%;
        font-size: 14px;
    }
}

.top50 {
    margin-top: 20px;
}

.filtre {
    .el-input-number {
        width: 100% !important;
    }
}

.input-element {
    width: 50%;
}

.nav {
    font-size: 18px;
    color: grey;
    padding: 0;
    padding-bottom: 20px;
    margin: 0;
    // border: 1px solid red;

    span {
        margin: 0 5px;
        cursor: pointer;
        margin-left: 10px;
        margin-right: 10px;
    }

    .active {
        font-weight: bold;
        color: rgb(46, 216, 74);
    }
}

@media only screen and (max-width: 600px) {
    .input-element {
        width: 80%;
    }

    .main-page {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .coloana {
            width: 95%;
        }
    }

    .el-tooltip__popper {
        width: 90%;
    }
}
</style>
